import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './Dashboard.css';

function Dashboard({ onLogout }) {
  return (
    <div className="dashboard-page">
      <Navigation onLogout={onLogout} />

      <div className="container">
        <div className="page-header">
          <div>
            <h1>Dashboard</h1>
            <p>Bem-vindo ao painel de controle do QRBlant</p>
          </div>
        </div>

        <div className="dashboard-grid">
          <Link to="/qrcodes" className="dashboard-card qrcodes">
            <div className="card-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="7" height="7" stroke="currentColor" strokeWidth="2"/>
                <rect x="14" y="3" width="7" height="7" stroke="currentColor" strokeWidth="2"/>
                <rect x="3" y="14" width="7" height="7" stroke="currentColor" strokeWidth="2"/>
                <rect x="14" y="14" width="3" height="3" fill="currentColor"/>
                <rect x="18" y="14" width="3" height="3" fill="currentColor"/>
                <rect x="14" y="18" width="3" height="3" fill="currentColor"/>
              </svg>
            </div>
            <div className="card-content">
              <h2>QR Codes</h2>
              <p>Criar, gerenciar e personalizar seus QR Codes</p>
            </div>
            <div className="card-arrow">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Link>

          <Link to="/reports" className="dashboard-card reports">
            <div className="card-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 3v18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M18 17V9M13 17v-4M8 17v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="card-content">
              <h2>Relatórios</h2>
              <p>Analytics avançado e estatísticas de acessos</p>
            </div>
            <div className="card-arrow">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </Link>
        </div>

        <div className="features-section">
          <h2>Recursos do Sistema</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Geração Rápida</h3>
              <p>Crie QR Codes personalizados em segundos</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎨</div>
              <h3>Personalização Total</h3>
              <p>Cores, logos e estilos customizáveis</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Analytics Completo</h3>
              <p>Rastreamento e métricas detalhadas</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🗺️</div>
              <h3>Geolocalização</h3>
              <p>Veja de onde seus QR Codes são acessados</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
